import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { Settings } from "@material-ui/icons";
import { IVjtData } from "../../../../../web-services/models/vjt-data";
import { IVjtTableProps } from "./props";
import "./vjt-table.scss";
import { kiirasTipusok } from "../../../../../helpers/kiiras-tipusok";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function VjtTable(props: IVjtTableProps)
{
    const renderDisplayedInfo = (elem: IVjtData) => {
        if (elem.kiirasTipus === 1) return elem.statikusSzoveg;
        else if (elem.kiirasTipus === 2) return elem.parkingLotMegnevezes;
        return "";
    };

    return (
        <TableContainer component={Paper} className="vjt-table" >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Sorszám</TableCell>
                        <TableCell>Megnevezés</TableCell>
                        <TableCell>Portal IP</TableCell>
                        <TableCell>Kiírás típus</TableCell>
                        <TableCell>Megjelenített információ</TableCell>
                        <TableCell>Sablon</TableCell>
                        <TableCell>Lehetőségek</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((row, i) => (
                        <TableRow
                            key={i}
                        >
                            <TableCell>{row.sorszam}</TableCell>
                            <TableCell>{row.megnevezes}</TableCell>
                            <TableCell>{row.portalIp}</TableCell>
                            <TableCell>{kiirasTipusok.get(row.kiirasTipus) || ""}</TableCell>
                            <TableCell>{renderDisplayedInfo(row)}</TableCell>
                            <TableCell>{row.sablonMegnevezes}</TableCell>
                            <TableCell>
                                <Button color="primary" variant="contained" startIcon={<Settings />} onClick={() => props.onModifyButtonClick(row)}>
                                    Módosítom
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
